"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var merch_components_1 = require("@carvana/merch-components");
var react_1 = __importStar(require("react"));
var Search = (0, merch_components_1.createComponent)('svg', {
    className: '-:text-blue-7'
});
exports.default = (0, react_1.forwardRef)(function (props, ref) { return (react_1.default.createElement(Search, __assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props),
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 0.000366211C3.13401 0.000366211 0 3.13437 0 7.00037C0 10.8664 3.13401 14.0004 7 14.0004C8.57234 14.0004 10.0236 13.482 11.1922 12.6068L14.2929 15.7075C14.6834 16.098 15.3166 16.098 15.7071 15.7075C16.0976 15.3169 16.0976 14.6838 15.7071 14.2933L12.6064 11.1925C13.4816 10.024 14 8.5727 14 7.00037C14 3.13437 10.866 0.000366211 7 0.000366211ZM2 7.00037C2 4.23894 4.23858 2.00037 7 2.00037C9.76142 2.00037 12 4.23894 12 7.00037C12 9.76179 9.76142 12.0004 7 12.0004C4.23858 12.0004 2 9.76179 2 7.00037Z", fill: "currentColor" }))); });
//# sourceMappingURL=Search.js.map